import React, { useState, useEffect } from 'react';
import { styled } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import { Typography, Grid, useTheme,Backdrop } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles, { getMuiTheme } from "./styles";
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CalculateIcon from '@mui/icons-material/Calculate';
import { pathOr } from "ramda";
import { FaIcon } from "../../../../../";
import { getCalculations } from '../../../../../../common/policyCalculation';
import SkeletonShell from "../../../../../../components/Skeleton/index";
import {Skeleton } from '../../../../../../components';
import { configureDashlet,configureDashletLoading } from "../../../../../../store/actions/dashboard.actions";
import { toast } from "react-toastify";
import { ProgressBar } from "../";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import SchoolIcon from '@mui/icons-material/School';
import ElderlyIcon from '@mui/icons-material/Elderly';
import SecurityIcon from '@mui/icons-material/Security';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PolicyIcon from '@mui/icons-material/Policy';
import MoneyIcon from '@mui/icons-material/Money';
import SavingsIcon from '@mui/icons-material/Savings';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
const makeid=()=> {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

export default function CustomCardList({ data, setValue, value, allTabFilter, isDashletUpdated, setAllTabFilter }) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const goals = {
  'Health':<HealthAndSafetyIcon key={makeid()} fontSize="large"/>,
  'Education':<SchoolIcon key={makeid()} fontSize="large"/>,
  'Retirement':<ElderlyIcon key={makeid()} fontSize="large"/>, 
  'Lifestyle Protection':<SecurityIcon key={makeid()} fontSize="large"/>, 
  'Income Protection':<AttachMoneyIcon key={makeid()} fontSize="large"/>, 
  'Major Investments':<SavingsIcon key={makeid()} fontSize="large"/>,
  'Major Investment':<SavingsIcon key={makeid()} fontSize="large"/>,
  '':<PolicyIcon key={makeid()} fontSize="large"/>
 }

  const dataList = pathOr([], ['data'], data);
  const dataResult = pathOr([], ['result'], data);
  const listTypeStatic = pathOr(false, ['listTypeStatic'], data);
  const [dashId, setDashId] = useState(pathOr('', ['id'], data));
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogDescription, setDialogDescription] = useState('');
  // const [showLoading, setShowLoading] = useState(isDashletUpdated.includes(dashId));
  const [loading, setLoading] = useState(false);
  const { dashboardData } = useSelector((state) => state.dashboard);
  const { userPreference } = useSelector((state) => state.config);
  // const currencies = pathOr([], ["attributes", "CurrenciesRecords"], userPreference);
  // console.log("dddddddddddddddd",pathOr(false, ['id'], data),isDashletUpdated)

  const filters = pathOr([], [0, 'dashlets'], dashboardData).filter(element => element.data.subType === 'Filter');
  const filterarr = [];
  Object.values(filters).map((row) => {
    Object.values(row.data.data).map((fld) => {
      filterarr[fld.name] = fld;
    });
  });

  const { configureDashletLoading } = useSelector(
    (state) => state.dashboard,
  );
  const [expanded, setExpanded] = React.useState(false);
  
  const handleExpandClick = (redirect, redirectData) => {
    if (redirect) {
      setValue(redirect)
    } else {
      if (dataList.redirectOn) {
  
        let redirectFieldsArray = []
        pathOr([], ['redirectFields'], dataList).map((rRow) => {
          redirectFieldsArray.push({ name: rRow, value: redirectData[pathOr('', ['redirectName'], dataList)] })
        })
        // console.log(dataList.redirectOn,redirectData,...redirectFieldsArray)
        let redirectDestructData = [redirectFieldsArray]
        const params = {
          "configureDashlet": {
            "id": pathOr('', ['redirectDashlet'], dataList),
            "module": "HomeApp",
            "configure": "true",
            "redirected": "true",
            'type': 'custom',
            'data': { data: pathOr([], [0], redirectDestructData) },
            'currentTab': pathOr('', ['redirectOn'], dataList),
            'dashlets': []
          }

        };
        try {
          setLoading(true);
          dispatch(configureDashlet(params)).then(function (res) {
            if (res.data.status === 200) {
              setAllTabFilter(pathOr([], ['data', 'allTabFilter'], res))
              toast('Dashlet Updated Successfully!')
              setValue(dataList.redirectOn)
              // setLoading(false);

            } else {
              toast('Something went wrong!');
              setLoading(false);

            }
          });
        } catch (e) {
          toast('Something went wrong!');

        }


      } else {
        setExpanded(!expanded);
      }
    }
  };

  const handleClickOpen = (ttle, tdesc) => {
    setDialogTitle(ttle)
    setDialogDescription(tdesc)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));
  const handleCheck = (rData, val) => {
    return rData.some(item => val === item);
  }

  const showListTypeStatic = (fieldKey, fieldNum, cardNum, queryDataCurrencies, returnDataCurrencies) => {
    let field = pathOr('', ['field'], fieldKey)
    return <Grid container
      direction="row"
      // justifyContent="center"
      alignItems="center"
      spacing={0}
      key={makeid()}
    >
      <Grid item xs={12} key={makeid()}>
        <Typography variant="subtitle1" className={classes.fieldLabel} key={makeid()}>
          {pathOr('', ['label'], fieldKey)}
          :
        </Typography>
      </Grid>

    </Grid>
  }
  const showCardBox = (cardItem, cardNum, dataList) => {
    console.log("Show Card Box",data,goals)
    // console.log(cardItem,cardNum,dataList,allTabFilter)
    const cardList = pathOr([], ['lists'], cardItem);
    let queryDataCurrencies = pathOr([], ['currencyFields'], cardItem);
    let returnDataCurrencies = pathOr([], ['returnFields'], cardItem);
    let cardIcon = pathOr('',[pathOr('', [pathOr('', ['subTitle'], dataList)], cardItem)],goals);
    const cardTitle = pathOr(cardNum, [pathOr('', ['title'], dataList)], cardItem);   
    const cardTitleStart = pathOr('', ['data','titleStart'], data);   
    const cardSubTitle = pathOr('', [pathOr('', ['subTitle'], dataList)], cardItem);
    const cardDescriptionStart = pathOr('', ['data','descriptionStart'], data);
    const cardDescription = pathOr('',[pathOr('', ['data','description'], data)],cardItem);
    const cardTotal = pathOr(false,[pathOr('', ['data','total'], data)],cardItem);
    const cardDescriptionEnd = pathOr('', ['data','descriptionEnd'], data);
    const descriptionElse=pathOr('', ['data','descriptionElse'], data);
     let progressData = {
      isHeader: false,
      label: 'Risk Value',
      isHelpText: false,
      HelpDescription: pathOr('', [pathOr('', ['subTitle'], dataList)], cardItem),
      isPopupActive: true,
      isFieldLabel: false,
      dataLength: pathOr([], ['data'], dataResult).length,
      height: 12,
      isProgressText: false
    };
   
    return <CardContent key={makeid()}>

      <Stack direction="row" spacing={2} style={{ justifyContent: "center", display: "flex" }} key={makeid()}>
        <Avatar alt={pathOr('', [pathOr('', ['subTitle'], dataList)], cardItem)} sx={{ bgcolor: theme.palette.primary.main,height:'56px',width:'56px' }} key={makeid()}>
          {cardIcon!==''?cardIcon:null}
        </Avatar>
      </Stack>
      <Typography variant="h6" align="center" color="secondary" key={makeid()}>
        {cardSubTitle} 
   
      </Typography>
      <Typography  align="center" component="div" key={makeid()}>
       {cardTitleStart}
        {/* {getCalculations('getValueWithCurrency',cardTitle)} */}
        {pathOr(false, ['isPercent'], dataList)?getCalculations('getValueOnlyInDecimal',cardTitle)+'%':getCalculations('getValueWithCurrency',cardTitle,[],allTabFilter)}
        {/* <Tooltip
      title={cardSubTitle} 
      placement="top-start"
    ><ErrorOutlineIcon color="primary" size="small" onClick={()=>handleClickOpen(cardSubTitle,cardSubTitle)} /></Tooltip> */}

      </Typography>
     
      <Typography align="center" color="primary" key={makeid()}>
        {cardTotal?
        cardDescriptionStart+
        getCalculations('getValueOnlyInDecimal',cardDescription,[],allTabFilter)+
        cardDescriptionEnd:descriptionElse}
      </Typography>
      {pathOr(false, ['isProgressShow'], data)?<ProgressBar key={cardNum} data={progressData} percent={isNaN(cardTitle)?cardTitle:0} allTabFilter={allTabFilter} />:null}



    </CardContent>
  };

  return (
    <MuiThemeProvider theme={getMuiTheme(theme)} key={makeid()}>
{configureDashletLoading?<Backdrop className={classes.backdrop} open={true}>
        <Skeleton count={7} />
      </Backdrop>:
      <Box key={makeid()}>
        <Grid container
          direction="row"
          // justifyContent="center"
          alignItems="center"
          spacing={1}
          key={makeid()}
        >
          {pathOr([], ['data'], dataResult).length ? Object.values(pathOr([], ['data'], dataResult)).map((cardItem, cardNum) =>
         
            <Grid key={makeid()} item sm={pathOr('12', ['grid', 'sm'], dataList)} xs={pathOr('12', ['grid', 'xs'], dataList)} onClick={() => handleExpandClick(cardItem.redirectOn, cardItem)}>
              {
              // loading === cardItem['id'] ? <SkeletonShell layout='Card' display key={makeid()} /> : 
              <Card variant="outlined" className={pathOr('',[7,'goal'],allTabFilter).toString() === pathOr('false',['id'],cardItem).toString() ? pathOr(false, ['borderDisable'], data)?classes.borderDisable:classes.currentCard : ''} key={makeid()}>
                {showCardBox(cardItem, cardNum, dataList)}

              </Card>}
            </Grid>

          ) : <Grid key={makeid()} xs="12" sm="12"><Card variant="outlined" key={makeid()} ><CardContent key={makeid()}><Typography align="center" color="textSecondary" key={makeid()}>No Data</Typography></CardContent></Card></Grid>}
        </Grid>

        <Dialog open={open} onClose={handleClose} key={makeid()}>
          <DialogTitle key={makeid()}>{dialogTitle}</DialogTitle>
          <DialogContent key={makeid()}>
            <DialogContentText key={makeid()}>
              {dialogDescription}
            </DialogContentText>

          </DialogContent>
          <DialogActions key={makeid()}>
            <Button onClick={handleClose}>Close</Button>

          </DialogActions>
        </Dialog>
      </Box>}
    </MuiThemeProvider>
  );
}
